export default __webpack_public_path__ + "static/media/biz-sole.baf26d9f.svg";